/**
 * Created by Ivan on 28.05.2026.
 */

const PendingRewards = function () {
    this.pending = {};
    this.releases = {};
    this.origins = {};
};

PendingRewards.prototype.add = function (type, amount, onConsume) {
    this.pending[type] = (this.pending[type] || 0) + amount;
    this.releases[type] = this.releases[type] || 0;

    const origin = this.addOrigin(type, amount);

    const epoch = this.releases[type];
    let consumed = false;

    return () => {
        if (consumed || epoch !== this.releases[type]) {
            return;
        }
        consumed = true;

        this.pending[type] -= amount;
        this.removeOrigin(type, origin);

        if (this.pending[type] <= 0) {
            delete this.pending[type];
            delete this.origins[type];
        }

        if (onConsume) {
            onConsume();
        }
    };
};

PendingRewards.prototype.addOrigin = function (type, amount) {
    const origin = {
        amount,
        time: Date.now(),
        screen: cleverapps.environment && cleverapps.environment.getScreen(),
        location: cleverapps.environment && cleverapps.environment.locationId,
        focus: cleverapps.focusManager && cleverapps.focusManager.focus
    };

    this.origins[type] = (this.origins[type] || []).concat(origin).slice(-PendingRewards.MAX_ORIGINS);

    return origin;
};

PendingRewards.prototype.removeOrigin = function (type, origin) {
    if (this.origins[type]) {
        this.origins[type] = this.origins[type].filter((item) => item !== origin);
    }
};

PendingRewards.prototype.release = function (type) {
    if (this.pending[type]) {
        delete this.pending[type];
        delete this.origins[type];
        this.releases[type] += 1;
    }
};

PendingRewards.prototype.get = function (type) {
    return this.pending[type] || 0;
};

PendingRewards.prototype.describeOrigin = function (origin, now) {
    const parts = [`reward=${origin.amount}`, `age=${Math.round((now - origin.time) / 1000)}s`];

    if (origin.screen) {
        parts.push(`screen=${origin.screen}`);
    }

    if (origin.location !== undefined) {
        parts.push(`location=${origin.location}`);
    }

    if (origin.focus && origin.focus !== origin.screen) {
        parts.push(`focus=${origin.focus}`);
    }

    return parts.join(" ");
};

PendingRewards.prototype.describeType = function (type, now) {
    const parts = [`${type}: pending=${this.pending[type] === undefined ? 0 : this.pending[type]}`];

    if (this.releases[type]) {
        parts.push(`releases=${this.releases[type]}`);
    }

    const origins = (this.origins[type] || []).map((origin) => this.describeOrigin(origin, now));

    if (origins.length) {
        parts.push(`(${origins.join(", ")})`);
    }

    return parts.join(" ");
};

PendingRewards.prototype.describe = function () {
    const now = Date.now();
    const released = Object.keys(this.releases).filter((type) => this.releases[type] > 0 && this.pending[type] === undefined);
    const types = Object.keys(this.pending).concat(released);

    return types.map((type) => this.describeType(type, now)).join(" | ") || "pending=0";
};

PendingRewards.MAX_ORIGINS = 5;

cleverapps.pendingRewards = new PendingRewards();
